'use client';
import React from 'react';
import Footer from '@/components/layout/Footer/Footer';
import Header from '@/components/layout/Header/Header';
import Subscribe from '@/components/layout/Subscribe';
import { usePathname, useSearchParams } from 'next/navigation';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useReportWebVitals } from '@/hooks/utils';
import MobileNavbar from '@/components/layout/MobileNavbar/MobileNavbar';
import { LoggingView } from '@/utils/logger';

const LAYOUT_FILTER_ROUTE = {
  ['/search']: {
    header: false,
    subscribe: false,
    footer: false,
  },
};

const initialFilterValue = {
  header: true,
  subscribe: true,
  footer: true,
};

type LayoutClientProps = {
  children: React.ReactNode;
};

function LayoutClientComponent({ children }: LayoutClientProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  useReportWebVitals();

  const filterOption = LAYOUT_FILTER_ROUTE[pathname as keyof typeof LAYOUT_FILTER_ROUTE] ?? initialFilterValue;

  // Get URL and page title for LoggingView params
  const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
  const pageTitle = typeof window !== 'undefined' ? document.title : '';

  return (
    <LoggingView params={{ page_location: url, page_path: pathname, page_title: pageTitle }}>
      {filterOption.header && <Header />}
      {children}
      {filterOption.subscribe && <Subscribe />}
      {filterOption.footer && <Footer />}
      <MobileNavbar />
      <ReactQueryDevtools initialIsOpen={false} />
    </LoggingView>
  );
}

const LayoutClient = React.memo(LayoutClientComponent);

export default LayoutClient;
